import './App.scss';

//theme
import 'primereact/resources/themes/lara-light-indigo/theme.css';

//core
import 'primereact/resources/primereact.min.css';

import { NavigatingRoutes } from './routes/Routes';
import { client } from './apollo_server_connection';
import { ApolloProvider } from '@apollo/client';

function App() {
  return (
    <>
      <ApolloProvider client={client}>
        <NavigatingRoutes />
      </ApolloProvider>
    </>
  );
}

export default App;
